//Copyright Open Trade Technology Ltd. 2023. All rights reserved.

import React, { ReactElement } from 'react'
import TransactionList from '@react/components/TransactionList'
import { Paper, Typography } from '@mui/material'

export default function LenderTransactionPage(): ReactElement {
  const [numberOfDays, setNumberOfDays] = React.useState<number>(30)
  return (
    <React.Fragment>
      <Paper sx={{ padding: 4, margin: 2, borderRadius: 4 }}>
        <>
          <Typography variant="h4" fontWeight={'bold'} align="left">
            Transactions
          </Typography>
          <div style={{ marginBottom: '16px' }}>
            <Typography variant="subtitle1" gutterBottom>
              Show transactions for:
            </Typography>
            <select
              value={numberOfDays}
              onChange={(e) => setNumberOfDays(Number(e.target.value))}
              style={{ padding: '8px', borderRadius: '4px' }}
            >
              <option value={7}>Last 7 days</option>
              <option value={30}>Last 30 days</option>
              <option value={90}>Last 90 days</option>
              <option value={365}>Last 365 days</option>
              <option value={0}>All</option>
            </select>
          </div>
          {numberOfDays && <TransactionList numberOfDays={numberOfDays} />}
          {!numberOfDays && <TransactionList />}
        </>
      </Paper>
    </React.Fragment>
  )
}
